(function () {
  var SELECTOR = '[data-palpa-sponge-exploded]';
  var CONCURRENCY = 6;

  function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v;
  }

  function ease(t) {
    return t * t * (3 - 2 * t);
  }

  function setup(root) {
    if (root.dataset.psexReady === 'true') return;
    root.dataset.psexReady = 'true';

    var stage = root.querySelector('.psex__stage');
    var canvas = root.querySelector('.psex__canvas');
    var intro = root.querySelector('.psex__intro');
    var callouts = Array.prototype.slice.call(root.querySelectorAll('.psex__callout'));
    var payload = root.querySelector('[data-psex-frames]');
    if (!stage || !canvas || !payload) return;

    var urls;
    try {
      urls = JSON.parse(payload.textContent);
    } catch (error) {
      return;
    }
    if (!urls.length) return;

    var sequenceEnd = parseFloat(root.dataset.sequenceEnd) / 100 || 0.6;
    var introEnd = parseFloat(root.dataset.introEnd) / 100 || 0.12;

    /* The timings below are written against the full scroll the merchant asked
       for, but the track is only as tall as the part of it that does something —
       see the section's Liquid. `span` is how much of that full scroll survived,
       so multiplying by it reads the timings back at their original pace over
       the shorter track. */
    var span = parseFloat(root.dataset.span) / 100 || 1;
    var settle = parseFloat(root.dataset.settle) / 100 || 0.08;
    var introSettle = parseFloat(root.dataset.introSettle) / 100 || 0.14;

    var ctx = canvas.getContext('2d');
    var frames = new Array(urls.length);
    var stageHeight = 0;
    var lastDrawn = -1;
    var wanted = 0;
    var queued = false;
    var scrolling = false;
    var nextToLoad = 0;
    var inFlight = 0;

    function draw(index) {
      var image = frames[index];
      if (!image) {
        // fall back to the closest frame already decoded
        for (var offset = 1; offset < frames.length; offset += 1) {
          if (frames[index - offset]) {
            index -= offset;
            break;
          }
          if (frames[index + offset]) {
            index += offset;
            break;
          }
        }
        image = frames[index];
        if (!image) return;
      }
      if (index === lastDrawn) return;
      lastDrawn = index;
      if (canvas.width !== image.naturalWidth) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      }
      ctx.drawImage(image, 0, 0);
    }

    function pump() {
      while (inFlight < CONCURRENCY && nextToLoad < urls.length) {
        (function (index) {
          var image = new Image();
          inFlight += 1;
          image.onload = function () {
            frames[index] = image;
            inFlight -= 1;
            if (index === 0 || index === wanted) draw(wanted);
            pump();
          };
          image.onerror = function () {
            inFlight -= 1;
            pump();
          };
          image.src = urls[index];
        })(nextToLoad);
        nextToLoad += 1;
      }
    }

    function apply() {
      queued = false;
      var rect = root.getBoundingClientRect();
      var travel = rect.height - stageHeight;
      var p = travel > 0 ? clamp((-rect.top / travel) * span, 0, 1) : 0;

      var pFrames = clamp(p / sequenceEnd, 0, 1);
      wanted = Math.round(pFrames * (urls.length - 1));
      draw(wanted);

      var pIntro = 1 - ease(clamp((p - introEnd) / introSettle, 0, 1));
      root.style.setProperty('--psex-intro', pIntro.toFixed(4));
      if (intro) intro.dataset.hidden = pIntro < 0.001 ? 'true' : 'false';

      callouts.forEach(function (callout) {
        var from = parseFloat(callout.dataset.revealAt) / 100;
        var r = ease(clamp((p - from) / settle, 0, 1));
        callout.style.setProperty('--r', r.toFixed(4));
        callout.dataset.hidden = r < 0.001 ? 'true' : 'false';
      });
    }

    function request() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    }

    function onResize() {
      stageHeight = stage.offsetHeight;
      request();
    }

    new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        if (visible) pump();
        if (visible === scrolling) return;
        scrolling = visible;
        if (visible) {
          window.addEventListener('scroll', request, { passive: true });
          onResize();
        } else {
          window.removeEventListener('scroll', request);
        }
      },
      { rootMargin: '200% 0px' }
    ).observe(root);

    window.addEventListener('resize', onResize, { passive: true });
    onResize();
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
